module.exports = __webpack_public_path__ + "media/images/icons/female-5ba58240457f69e7d754d23716b38762.png";